import React, { useState } from "react";
import "./evaluation.css";

const TestEvaluator = ({ test, onBack }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const currentQuestion = test.questions[currentQuestionIndex];

  const handleAnswerSelection = (answerIndex) => {
    setAnswers({ ...answers, [currentQuestionIndex]: answerIndex });
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < test.questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setSubmitted(true);
    }
  };

  const calculateScore = () => {
    let score = 0;
    test.questions.forEach((q, index) => {
      // Solo evalúa las preguntas que no sean abiertas (que tengan respuesta correcta)
      if (q.type !== "open" && answers[index] === q.correctAnswer) score++;
    });
    return score;
  };

  // Contar cuántas preguntas son calificables (no son abiertas)
  const scoreableQuestionsCount = test.questions.filter((q) => q.type !== "open").length;

  return (
    <div className="test-evaluator">
      <h2>{test.title}</h2>

      {!submitted ? (
        <div className="question-block">
          <p className="question-number">
            Pregunta {currentQuestionIndex + 1} de {test.questions.length}
          </p>
          <p className="question-text">{currentQuestion.question}</p>

          {currentQuestion.type === "open" ? (
            <textarea
              className="open-answer-text"
              placeholder="Escribe tu respuesta aquí..."
              value={answers[currentQuestionIndex] || ""}
              onChange={(e) => handleAnswerSelection(e.target.value)}
              rows="5"
              style={{ width: "100%", padding: "10px", marginTop: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
            />
          ) : (
            currentQuestion.options.map((option, index) => (
              <label
                key={index}
                className={`option ${
                  answers[currentQuestionIndex] === index ? "selected" : ""
                }`}
              >
                <input
                  type="radio"
                  name={`question-${currentQuestionIndex}`}
                  value={index}
                  onClick={() => handleAnswerSelection(index)}
                />
                {option}
              </label>
            ))
          )}

          <button
            className="next-button"
            onClick={handleNextQuestion}
            disabled={
              currentQuestion.type === "open"
                ? !answers[currentQuestionIndex] || answers[currentQuestionIndex].trim() === ""
                : answers[currentQuestionIndex] === undefined
            }
          >
            {currentQuestionIndex === test.questions.length - 1
              ? "Finalizar"
              : "Siguiente"}
          </button>
        </div>
      ) : (
        <div className="results">
          <h3>Resultados:</h3>
          <p>
            Puntaje: {calculateScore()} / {scoreableQuestionsCount}
          </p>
          {test.questions.some((q) => q.type === "open") && (
            <p style={{ fontSize: "0.9em", color: "#666", marginTop: "10px" }}>
              Las preguntas de respuesta abierta serán evaluadas y discutidas durante la retroalimentación en vivo.
            </p>
          )}
          <button onClick={onBack}>Volver a los Tests</button>
        </div>
      )}
    </div>
  );
};

export default TestEvaluator;
